// extracted by mini-css-extract-plugin
export var extraLarge = "Heading-module--extraLarge--v7ynI";
export var extraSmall = "Heading-module--extraSmall--uK6xy";
export var heading = "Heading-module--heading--gcwfV";
export var large = "Heading-module--large--qmJRd";
export var medium = "Heading-module--medium--wxqvM";
export var small = "Heading-module--small--ZzNO+";